module.exports = __webpack_public_path__ + "img/03_full.7640239a.jpg";